export default function MultipleChoiceInputIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="8.25" stroke="#5E718D" strokeWidth="1.5" />
    </svg>
  );
}
